export default {
  name: 'marking--outP',
  apiService: 'shoes',
  apiPath: '/admin/out_p',
};
